<section>
  <div flex fxLayout="column" fxLayoutAlign="center"></div>
</section>

<form [formGroup]="currentForm">
  <section fxLayout="column" fxLayoutAlign=" start">
    <div class="wrapper">
      <div class="col" fxFlex="100">
        <mat-form-field appearance="outline">
          <mat-label>Neuer Status</mat-label>
          <mat-select formControlName="newState">
            <mat-option *ngFor="let ele of metaService.feederContractStatus" [value]="ele.value">
              {{ ele.displayName }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <mat-form-field appearance="outline" style="margin-bottom: 0.5rem" fxFlexAlign="stretch">
      <mat-label>Kommentar:</mat-label>
      <textarea
        matInput
        type="text"
        placeholder="Kommentar"
        rows="3"
        maxlength="255"
        required
        formControlName="comment"></textarea>
    </mat-form-field>
  </section>
</form>

<div class="button-container" fxLayout="row" fxLayoutAlign="end stretch" fxLayoutGap="20px">
  <button mat-stroked-button color="primary" id="modal-cancel-button" (click)="cancel()">Abbrechen</button>
  <button mat-raised-button color="primary" id="modal-confirm-after-meter-change" (click)="confirm()">
    <span>Status ändern</span>
  </button>
</div>
